import Parse from 'parse'
import { createUserData, getSystemLanguage } from '@/helpers/utils'

function currentParseUserLanguage () {
  const user = Parse.User.current()
  if (user && user.has('language')) {
    return user.get('language')
  } else {
    return null
  }
}

// Initializes the user information in the store based on the currently logged
// in Parse user.
// @param store: the Vuex store
// @param
export default function (store) {
  const language = currentParseUserLanguage() || getSystemLanguage() || 'en'
  store.commit('setUILanguage', language)
  const user = Parse.User.current()
  if (user) {
    store.commit('setCurrentUserId', user.id)
    store.commit('setUserData', createUserData(user, user.get('address')))
  }
}



// WEBPACK FOOTER //
// ./src/core/initialize-store.js